import { getImageUrlFromName } from '../../../util'

const DisplayPropertyLayout = ({ layout, value }) => {
  // console.log('Display properties layout::', value)
  const icon = require('../../../assets/images/checkCircle.svg').default
  return (
    <div
      style={{
        padding: '8px 20px 8px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#ff0000',
      }}
    >
      {value.map((item) => {
        return (
          <div
            style={{
              display: 'flex',
              // marginBottom: '-1rem',
              alignItems: 'flex-start',
              color: 'var(--gray80)',
              margin: '16px 0px',
            }}
          >
            <img
              src={getImageUrlFromName(item.icon_name)}
              alt="icon"
              style={{ marginRight: '14px', width: '20px', height: '20px' }}
            ></img>
            <p
              className="body1"
              style={{ color: 'var(--gray100)', margin: '0px 0px' }}
            >
              {item.value}
            </p>
          </div>
        )
      })}
    </div>
  )
}

export default DisplayPropertyLayout
